module.exports = __webpack_public_path__ + "img/blog-grid-sidebar-light.b60a884e.png";